var t;!function(t){t.FILE="file",t.TEXT="text"}(t||(t={}));export{t as MessageTypeEnum};